import { boardEntryPoint } from '@jira/spa-apps__board/src/boardEntryPoint.entrypoint.tsx';
import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout/src/index.tsx';
import { ThemedLazySkeleton } from '@jira/platform__project-theme-components/src/ui/ThemedLazySkeleton.tsx';
import { JIRA_BOARD } from '@jira/platform__observability-capabilities/src/constants.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { jiraBusinessBoardCustomEmbedRoute } from '@jira/router-routes__business-board-routes/src/jiraBusinessBoardCustomEmbedRoute.tsx';
import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { jiraBusinessBoardResources } from './common/jiraBusinessBoardResources.tsx';

const boardEmbedPageEntryPoint = createChromelessEntryPoint({
	main: boardEntryPoint,
});

export const jiraBusinessBoardCustomEmbedRouteEntry: Route = createEntry(
	jiraBusinessBoardCustomEmbedRoute,
	() => ({
		group: 'classic-business',
		ufoName: 'jwm.jwm-board-embed',
		layout: chromelessLayout,
		skeleton: ThemedLazySkeleton,
		resources: jiraBusinessBoardResources(),
		entryPoint: () => boardEmbedPageEntryPoint,
		supportsProjectTheme: 'full',
		meta: {
			capability: JIRA_BOARD,
		},

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
